/**
 * Giftera × Ella — giftera-relations.js (încărcat cu defer de sections/giftera-relations.liquid).
 *
 * Comutatorul „Pentru ea / Pentru el” din secțiunea „Pentru cine cauți cadoul?”:
 *   - semantică de taburi: săgeți, Home și End mută selecția; Tab intră în cardurile grupului activ;
 *   - ultima alegere se ține în sessionStorage (cheia gf:relation_gender);
 *   - măsurare: la comutare și la click pe o relație se emite pe document
 *     CustomEvent('gf:relation_select', { detail: { gender, relation } }) și, dacă există
 *     window.dataLayer, se face push cu { event: 'gf_relation_select', gender, relation }.
 *     La comutare, relation este gol. La butonul „Toate cadourile…”, relation este „toate”.
 *
 * Fără JS, grupurile se văd unul sub altul (vezi CSS-ul, blocul „Relații” din giftera-sections.css).
 */
(function () {
  'use strict';

  if (window.GifteraRelations) return;
  window.GifteraRelations = true;

  var STORE_KEY = 'gf:relation_gender';
  var doc = document;

  function readStored() {
    try {
      return window.sessionStorage.getItem(STORE_KEY) || '';
    } catch (error) {
      return '';
    }
  }

  function writeStored(gender) {
    try {
      window.sessionStorage.setItem(STORE_KEY, gender);
    } catch (error) {
      /* navigare privată sau stocare blocată: alegerea ține doar pe pagina curentă */
    }
  }

  function all(selector, scope) {
    return Array.prototype.slice.call(scope.querySelectorAll(selector));
  }

  function track(gender, relation) {
    var detail = { gender: gender, relation: relation };
    doc.dispatchEvent(new CustomEvent('gf:relation_select', { detail: detail }));
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: 'gf_relation_select', gender: gender, relation: relation });
    }
  }

  function select(root, gender) {
    var tabs = all('[data-gf-rel-tab]', root);
    var found = tabs.some(function (tab) {
      return tab.getAttribute('data-gf-rel-tab') === gender;
    });
    if (!found) return false;

    tabs.forEach(function (tab) {
      var on = tab.getAttribute('data-gf-rel-tab') === gender;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on) tab.removeAttribute('tabindex');
      else tab.setAttribute('tabindex', '-1');
    });
    all('[data-gf-rel-panel]', root).forEach(function (panel) {
      panel.classList.toggle('is-active', panel.getAttribute('data-gf-rel-panel') === gender);
    });
    root.setAttribute('data-gf-gender', gender);
    return true;
  }

  function setup(root) {
    if (!root) return;
    var stored = readStored();
    if (!stored || !select(root, stored)) {
      var first = root.querySelector('[data-gf-rel-tab]');
      if (first) select(root, first.getAttribute('data-gf-rel-tab'));
    }
  }

  function setupAll(scope) {
    all('[data-gf-relations]', scope || doc).forEach(setup);
  }

  doc.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var tab = target.closest('[data-gf-rel-tab]');
    if (tab) {
      var root = tab.closest('[data-gf-relations]');
      var gender = tab.getAttribute('data-gf-rel-tab');
      if (!root || tab.getAttribute('aria-selected') === 'true') return;
      select(root, gender);
      writeStored(gender);
      track(gender, '');
      return;
    }

    var card = target.closest('[data-gf-relation]');
    if (card) {
      var panel = card.closest('[data-gf-rel-panel]');
      track(panel ? panel.getAttribute('data-gf-rel-panel') : '', card.getAttribute('data-gf-relation') || '');
    }
  });

  doc.addEventListener('keydown', function (event) {
    var tab = event.target && event.target.closest ? event.target.closest('[data-gf-rel-tab]') : null;
    if (!tab) return;
    var root = tab.closest('[data-gf-relations]');
    if (!root) return;

    var tabs = all('[data-gf-rel-tab]', root);
    var index = tabs.indexOf(tab);
    var next = -1;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
    else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = tabs.length - 1;
    if (next < 0) return;

    event.preventDefault();
    if (next === index) return;
    var gender = tabs[next].getAttribute('data-gf-rel-tab');
    select(root, gender);
    tabs[next].focus();
    writeStored(gender);
    track(gender, '');
  });

  doc.addEventListener('shopify:section:load', function (event) {
    setupAll(event.target);
  });

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { setupAll(); }, { once: true });
  else setupAll();
})();
